module.exports = __webpack_public_path__ + "img/img-4-mobile.3ccf5679.png";